import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';

function LoginPage() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [sessionMessage, setSessionMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const msg = sessionStorage.getItem('loginRedirectMessage');
    if (msg) setSessionMessage(msg);
  }, []);

  const handleEmailChange = event => setLogin(event.target.value);
  const handlePasswordChange = event => setSenha(event.target.value);

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    try {
      let location = 'Indisponível';
      if (navigator.geolocation) {
        try {
          const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { timeout: 3000 }));
          location = `${pos.coords.latitude},${pos.coords.longitude}`;
        } catch (_) {}
      }
      const response = await axios.post(
        `${API_BASE_URL.LOGIN}`,
        { login, senha, location }
      );
      const { token, usuario, vinculo } = response.data;
      if (!token || !usuario || !vinculo) {
        throw new Error('Dados de login inválidos');
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(usuario));
      localStorage.setItem('vinculo', JSON.stringify(vinculo));
      localStorage.setItem('vinculos_all', JSON.stringify(vinculo));
      localStorage.setItem('login', usuario.login);
      localStorage.setItem('ano', new Date().getFullYear().toString());
      sessionStorage.removeItem('loginRedirectMessage');
      navigate('/seleciona_escola');
    } catch (error) {
      setErrorMessage('Login ou senha incorretos. Tente novamente.');
      console.error('Erro ao buscar itens:', error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url('/assets/desktop.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.55)',
        }}
      />

      {/* Card */}
      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: '380px',
          margin: '1rem',
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: '#fff',
          boxShadow: '0 12px 48px rgba(0,0,0,0.5)',
        }}
      >
        {/* Header verde */}
        <div
          style={{
            backgroundColor: '#198754',
            padding: '2rem 2rem 1.5rem',
            textAlign: 'center',
          }}
        >
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="64"
            height="64"
            style={{ borderRadius: '12px', marginBottom: '0.75rem' }}
          />
          <h4 style={{ color: '#fff', margin: 0, fontWeight: 700, letterSpacing: '0.5px' }}>
            Sistema de Gerenciamento
          </h4>
          
        </div>

        {/* Formulário */}
        <div style={{ padding: '2rem' }}>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="mb-3">
              <label style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.4rem', display: 'block', letterSpacing: '0.5px' }}>
                <i className="bi bi-person me-2"></i>USUÁRIO
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite seu usuário"
                value={login}
                onChange={handleEmailChange}
                required
                style={{ borderRadius: '8px', padding: '0.6rem 0.9rem' }}
              />
            </div>
            <div className="mb-3">
              <label style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.4rem', display: 'block', letterSpacing: '0.5px' }}>
                <i className="bi bi-lock me-2"></i>SENHA
              </label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  placeholder="Digite sua senha"
                  value={senha}
                  onChange={handlePasswordChange}
                  required
                  style={{ borderRadius: '8px', padding: '0.6rem 2.4rem 0.6rem 0.9rem' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                  aria-label={showPassword ? 'Esconder senha' : 'Mostrar senha'}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    color: '#6c757d',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '4px',
                    borderRadius: '4px',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={e => { e.target.style.color = '#212529'; }}
                  onMouseLeave={e => { e.target.style.color = '#6c757d'; }}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-slash-fill" style={{ fontSize: '1rem' }} />
                  ) : (
                    <i className="bi bi-eye-fill" style={{ fontSize: '1rem' }} />
                  )}
                </button>
              </div>
            </div>

            <div className="text-end mb-2">
              <button
                type="button"
                className="btn btn-link p-0"
                style={{ fontSize: '0.8rem', textDecoration: 'none' }}
                onClick={() => navigate('/recuperar-senha')}
              >
                Esqueci minha senha
              </button>
            </div>

            {sessionMessage && (
              <div
                className="alert alert-warning d-flex align-items-start gap-2 py-2 mb-3"
                role="alert"
                style={{ fontSize: '0.83rem', borderRadius: '8px' }}
              >
                <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1"></i>
                <span>{sessionMessage}</span>
              </div>
            )}
            {errorMessage && (
              <div
                className="alert alert-danger py-2 mb-3"
                role="alert"
                style={{ fontSize: '0.83rem', borderRadius: '8px' }}
              >
                <i className="bi bi-exclamation-triangle me-2"></i>
                {errorMessage}
              </div>
            )}

            <button
              type="submit"
              className="btn w-100"
              disabled={isLoading}
              style={{
                backgroundColor: '#198754',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '0.65rem',
                fontWeight: 600,
                fontSize: '0.95rem',
                letterSpacing: '0.5px',
                marginTop: '0.25rem',
              }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Entrando...
                </>
              ) : (
                <>
                  <i className="bi bi-box-arrow-in-right me-2"></i>
                  Entrar
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
